import Route from 'mewe/routes/route';

export default class AmbassadorsRoute extends Route {}
